const mutations = {
  SET_AVG_LIFE(state, payload) {
    state.push(payload.avgLife['0-5YRS']);
    state.push(payload.avgLife['5-10YRS']);
    state.push(payload.avgLife['10-20YRS']);
    state.push(payload.avgLife['20-30YRS']);
    state.push(payload.avgLife['30+YRS']);
  }
};
const getters = {
  getAvgLifeData: state => state
};

const state = [];

export default {
  state,
  getters,
  mutations
};
